import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const SkudDepartments = lazy(() => import('./departments/SkudDepartments'));
const SkudEmployees = lazy(() => import('./employees/SkudEmployees'));
const SubEmployeeSkudDetail = lazy(() => import('./skud-detail/SubEmployeeSkudDetail'));
const SkudReport = lazy(() => import('./report/SkudReport'));
const AbsenceAsks = lazy(() => import('./absence-asks/AbsenceAsks'));
const Workload = lazy(() => import('./workload/Workload'));
const EmployeeWorkload = lazy(() => import('./workload/EmployeeWorkload'));
const Employees = lazy(() => import('./employees/Employees'));
const DailyAttendances = lazy(() => import('./daily-attendances/DailyAttendances'));
const DepartmentsReport = lazy(() => import('./departments-report/DepartmentsReport'));
const BlocksDailyReport = lazy(() => import('./blocks-daily-report/BlocksDailyReport'));
const AttendanceReport = lazy(() => import('./attendance-report/AttendanceReport'));
const AttendanceReportTop = lazy(() => import('./attendance-report-top/AttendanceReport'));

const SkudConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  authRoles: authRoles.user,
  routes: [
    {
      path: 'apps/skud/departments',
      element: <SkudDepartments />,
    },
    {
      path: 'apps/skud/departments/:id',
      element: <SkudEmployees />,
    },
    {
      path: 'apps/skud/employees/:id',
      element: <SubEmployeeSkudDetail />,
    },
    {
      path: 'apps/skud/employers',
      element: <Employees />,
    },
    {
      path: 'apps/skud/report',
      element: <SkudReport />,
      auth: authRoles.top,
    },
    {
      path: 'apps/skud/daily-attendances',
      element: <DailyAttendances />,
    },
    {
      path: 'apps/skud/absence-asks',
      element: <AbsenceAsks />,
    },
    {
      path: 'apps/skud/workload',
      element: <Workload />,
    },
    {
      path: 'apps/skud/workload/:id',
      element: <EmployeeWorkload />,
    },
    {
      path: 'apps/skud/departments-report',
      element: <DepartmentsReport />,
    },
    {
      path: 'apps/skud/blocks-daily-report',
      element: <BlocksDailyReport />,
      auth: authRoles.top,
    },
    {
      path: 'apps/skud/attendance-report',
      element: <AttendanceReport />,
    },
    {
      path: 'apps/skud/attendance-report-top',
      element: <AttendanceReportTop />,
    },
  ],
};

export default SkudConfig;
